import React, { Component } from 'react'
import InfiniteScroll from 'react-infinite-scroller'
import { ArrowButton, Heading } from '@plurall/elo'
import { Link } from 'react-router-dom'
import Loading from 'plurall-loading'
import { NoResults } from 'components'
import { Client } from 'utils'
import QuestionFilters from './QuestionFilters'
import QuestionList from './QuestionList'

import styles from './QuestionPageList.module.scss'

class QuestionPageList extends Component {
  constructor(props) {
    super(props)
    this.currentPage = 1
    this.limit = 30
  }

  state = {
    text: '',
    tags: '',
    filters: [],
    filterSelected: {},
    loading: true,
    params: {},
    questions: [],
    renderData: false,
  }

  async componentDidMount() {
    let filters = await this.client.getFilters()
    filters = this.replaceNameFilters(filters)

    this.setState({ filters, loading: false })
  }
  client = new Client()

  handleFiltersChange = async (value, type) => {
    const filterSelected = { ...this.state.filterSelected, [type]: value }

    const params = { ...this.state.params, [type]: value.toString() }

    if (value.length === 0) {
      delete filterSelected[type]
      delete params[type]
    }

    this.setState({ filterSelected, params })

    let filters = await this.client.getFilters({
      ...params,
    })

    filters = this.replaceNameFilters(filters)

    this.setState({ filters, loading: false })
  }

  replaceNameFilters = filters =>
    filters.map(filter => {
      if (filter.paramName === 'exam_type') {
        return { ...filter, name: 'Todos os exames' }
      } else if (filter.paramName === 'difficulty_level') {
        return { ...filter, name: 'Níveis de dificuldade' }
      }
      return filter
    })

  fetchQuestions = async () => {
    this.currentPage = 1
    this.setState({ loading: true, renderData: false })
    const params = {
      limit: this.limit,
      page: this.currentPage,
      text: this.state.text,
      tags: this.state.tags && this.state.tags.split(','),
      ...this.state.params,
    }

    const { questions, total } = await this.client.getQuestions({ ...params })

    this.setState({ total, questions, loading: false, renderData: true })
  }

  handleChange = event => {
    this.setState({ [event.target.name]: event.target.value })
  }

  clearFiltersSelected = async () => {
    this.setState({ loading: true })
    let filters = await this.client.getFilters()
    filters = this.replaceNameFilters(filters)
    this.setState({
      filterSelected: {},
      params: {},
      text: '',
      tags: '',
      filters,
      questions: [],
      loading: false,
      renderData: false,
    })
  }

  handleExpandChange = async (questionSelected, index) => {
    const array = [...this.state.questions]
    array[index].expand = !array[index].expand
    if (!array[index].kind) {
      array[index].loading = true
      this.setState({ questions: array })
      const { question } = await this.client.getQuestion(questionSelected.id)
      const returnedQuestion = Object.assign(questionSelected, question)
      array[index] = returnedQuestion
      if (array[index].kind === 'undefined') {
        array[index].noResult = true
      }
      array[index].loading = false
    }
    this.setState({ questions: array })
  }

  loadMore = async () => {
    this.currentPage += 1

    const params = {
      limit: this.limit,
      page: this.currentPage,
      text: this.state.text,
      tags: this.state.tags && this.state.tags.split(','),
      ...this.state.params,
    }
    const { questions } = await this.client.getQuestions(params)

    this.setState({
      questions: [...this.state.questions, ...questions],
    })
  }

  loader = () => (
    <div className={styles['loader-wrapper']} key={0}>
      <Heading bold>Carregando mais questões...</Heading>
    </div>
  )

  renderQuestions = () => {
    const {
      loader,
      loadMore,
      state: { questions },
    } = this
    return (
      <InfiniteScroll
        pageStart={1}
        loadMore={loadMore}
        loader={loader()}
        hasMore={this.currentPage < Math.ceil(this.state.total / this.limit)}
      >
        {questions.length !== 0 && (
          <QuestionList
            questions={questions}
            total={this.state.total}
            handleExpandChange={this.handleExpandChange}
          />
        )}
        {this.state.total === 0 && <NoResults />}
      </InfiniteScroll>
    )
  }

  render() {
    const {
      state: { loading, filters, text, tags, renderData },
    } = this

    return (
      <>
        <div className={styles.header}>
          <Link to='/'>
            <ArrowButton direction='left' />
          </Link>
          <h1 className={styles.heading}>Buscar questão</h1>
        </div>

        <div className={styles.wrapper}>
          {loading ? (
            <div className={styles.loading}>
              <Loading logoMaxHeight='100' logoMaxWidth='100px' opacity='0.5' />
            </div>
          ) : (
            <>
              <QuestionFilters
                handleFiltersChange={this.handleFiltersChange}
                handleChange={this.handleChange}
                fetchQuestions={this.fetchQuestions}
                clearFiltersSelected={this.clearFiltersSelected}
                filters={filters}
                text={text}
                tags={tags}
                selected={this.state.filterSelected}
              />
              {renderData && this.renderQuestions()}
            </>
          )}
        </div>
      </>
    )
  }
}

export default QuestionPageList
